import React from "react";
import { Link } from 'react-router-dom';
import '../style/PaidCourses.css';


export default function PaidCourses() {

    return (
        <>

            <section className="section-8">
                <div className="paidbox ">
                    <h1>Paid courses</h1>
                    <img className="primg" src={require("../img/10.png")} alt="Error" />
                    <div className="box-8">
                        <div className="boxbox-8">
                            <div className="box-8img">
                                <p>1</p>
                                <img className="pimg" src={require("../img/imgp.png")} alt="Error" />
                            </div>
                            <h4 className="text-center">3Ds Max - Start</h4>
                            <div className="pricetag">
                                <h5>$59.99 <i class="fa-solid fa-tag"></i></h5>
                                <Link
                                    className="line btn btn-8" to="/Payment"><i
                                        class="fa-solid fa-bag-shopping"
                                    ></i> Purchase
                                </Link>
                            </div>
                        </div>
                        <div className="boxbox-8">
                            <div className="box-8img">
                                <p>1</p>
                                <img className="pimg" src={require("../img/imgp.png")} alt="Error" />
                            </div>
                            <h4 className="text-center">3Ds Max - Start</h4>
                            <div className="pricetag">
                                <h5>$59.99 <i class="fa-solid fa-tag"></i></h5>
                                <Link
                                    className="line btn btn-8" to="/Payment"><i
                                        class="fa-solid fa-bag-shopping"
                                    ></i> Purchase
                                </Link>
                            </div>
                        </div>
                        <div className="boxbox-8">
                            <div className="box-8img">
                                <p>1</p>
                                <img className="pimg" src={require("../img/imgp.png")} alt="Error" />
                            </div>
                            <h4 className="text-center">3Ds Max - Start</h4>
                            <div className="pricetag">
                                <h5>$59.99 <i class="fa-solid fa-tag"></i></h5>
                                <Link
                                    className="line btn btn-8" to="/Payment"><i
                                        class="fa-solid fa-bag-shopping"
                                    ></i> Purchase
                                </Link>
                            </div>
                        </div>
                        <div className="boxbox-8">
                            <div className="box-8img">
                                <p>1</p>
                                <img className="pimg" src={require("../img/imgp.png")} alt="Error" />
                            </div>
                            <h4 className="text-center">3Ds Max - Start</h4>
                            <div className="pricetag">
                                <h5>$59.99 <i class="fa-solid fa-tag"></i></h5>
                                <Link
                                    className="line btn btn-8" to="/Payment"><i
                                        class="fa-solid fa-bag-shopping"
                                    ></i> Purchase
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
